/* Fabric Themes sidebar: shows the first 48 links from the 'Fabric Themes' menu; 'See more' reveals 25 more menu links per click. */
/* Only collections that are in the menu are ever shown. */
(function () {
  if (window.__fvThemesMore) return;
  window.__fvThemesMore = true;
  var PAGE = 25;
  function reveal(ul, n) {
    var hidden = ul.querySelectorAll('li[data-fv-theme-extra][hidden]');
    for (var i = 0; i < hidden.length && i < n; i++) hidden[i].hidden = false;
    if (hidden.length <= n) { var item = ul.querySelector('.fv-themes-more-item'); if (item) item.parentNode.removeChild(item); }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fv-themes-more]');
    if (!btn) return;
    e.preventDefault();
    reveal(btn.closest('ul'), PAGE);
  });
  function showCurrent() {
    document.querySelectorAll('li[data-fv-theme-extra][hidden] a[aria-current]').forEach(function (a) {
      var li = a.closest('li'), ul = a.closest('ul'), guard = 0;
      while (li.hidden && guard++ < 200) reveal(ul, PAGE);
    });
  }
  if (document.readyState !== 'loading') showCurrent(); else document.addEventListener('DOMContentLoaded', showCurrent);
})();